import { render, staticRenderFns } from "./GlobalTitle.vue?vue&type=template&id=5d775faa&scoped=true"
import script from "./GlobalTitle.vue?vue&type=script&lang=js"
export * from "./GlobalTitle.vue?vue&type=script&lang=js"
import style0 from "./GlobalTitle.vue?vue&type=style&index=0&id=5d775faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d775faa",
  null
  
)

export default component.exports